var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletAltLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.50311H13C8.75736 5.50311 6.63604 5.50311 5.31802 6.84205C4 8.18099 4 10.336 4 14.646V17.6936C4 22.0036 4 24.1586 5.31802 25.4975C6.63604 26.8364 8.75736 26.8364 13 26.8364H19C23.2426 26.8364 25.364 26.8364 26.682 25.4975C28 24.1586 28 22.0036 28 17.6936V14.646C28 10.336 28 8.18099 26.682 6.84205C25.364 5.50311 23.2426 5.50311 19 5.50311Z",
    stroke: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 10.8365H13.3335",
    stroke: "current",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.5031V18.1698C20 17.227 20 16.7556 20.2929 16.4627C20.5858 16.1698 21.0572 16.1698 22 16.1698H26C26.9428 16.1698 27.4142 16.1698 27.7071 16.4627C28 16.7556 28 17.227 28 18.1698V19.5031C28 20.4459 28 20.9173 27.7071 21.2102C27.4142 21.5031 26.9428 21.5031 26 21.5031H22C21.0572 21.5031 20.5858 21.5031 20.2929 21.2102C20 20.9173 20 20.4459 20 19.5031Z",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAltLight);
export default __webpack_public_path__ + "static/media/Wallet_alt_light.7e5ca3f030a0494cde561c03ec9738bb.svg";
export { ForwardRef as ReactComponent };